<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiInformationVariant }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2>Claims</h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>

        <div class="claims-main-wrapper d-flex justify-space-around flex-wrap">
            <div class="claims-col-content">
                <h3>CLAIMS / REIMBURSEMENT OF EXPENSES:</h3>
                <v-divider class="mb-5" />
                <div class="content">
                    <h4>
                        An HMI Member may file for claims for reimbursement for expenses
                        incurred that should have been covered by their HMI Program.
                        However, these claims are subject for approval, based on the
                        following conditions:
                    </h4>

                    <div>
                        <ul v-for="(claimApproval, i) in claimApprovals" :key="i">
                            <li>{{ claimApproval }}</li>
                        </ul>
                    </div>

                    <h4>
                        HMI will validate and process claims for reimbursement only when
                        complete documents have been submitted to HMI within thirty (30)
                        calendar days after discharge from the hospital. The complete
                        documents must include the original copies of the following:
                    </h4>
                    <div>
                        <ul v-for="(claimsReimburse, i) in claimsReimburses" :key="i">
                            <li>{{ claimsReimburse }}</li>
                        </ul>
                    </div>
                    <h4>
                        HMI reserves the right to examine the member whose injury or
                        sickness is the basis of the claim and as often as it may
                        reasonably require during the pendency of the claim in question.
                    </h4>
                </div>

                <div class="reimbursement my-5">
                    <h3>Filing for Reimbursement</h3>
                    <v-divider />
                    <div class="proc-img">
                        <img src="../../../assets/Filing for Reimbursement.webp" alt="">
                    </div>
                </div>
            </div>

            <!-- Payment of claims -->
            <div class="claims-col-content">
                <h3>Payment of Claims</h3>
                <v-divider class="mb-5" />
                <div class="content">
                    <p>
                        HMI pays the approved reimbursement of medical expenses within
                        thirty (30) days from receipt of complete documents, based on HMI
                        rates. Claims with incomplete documents will not be accepted.
                    </p>
                    <p>
                        Approved reimbursement of medical expenses will be paid directly
                        to the member or parent/guardian payor. In case of death of the
                        member, HMI will release the claim to the legal heirs of the
                        member upon presentation of sufficient proof thereof. Accordingly,
                        such payment dischargers/releases HMI from all liabilities.
                    </p>
                    <p>
                        Upon payment of such claims, the member/parent/ guardian/payor
                        legal heirs shall sign a quit-claim discharging HMI from any and
                        all claims accruing by reason of his confinement for the sickness
                        or illness of which he is claiming reimbursement.
                    </p>
                </div>

                <h3>Request for Reconsideration</h3>
                <v-divider class="mb-5" />
                <div class="content">
                    <p>
                        If a claim for reimbursement is denied, or the member is not
                        satisfied or agreeable to the reimbursement approved by HMI, a
                        written request for reconsideration must be filed at the HMI Head
                        Office within ten (10) days from receipt of disapproved or
                        questioned reimbursement. Otherwise, the claim is deemed
                        satisfied or terminated. All receipts, bills, and other documents
                        existing at the time the original claim was made, but were not
                        submitted, shall not be considered by HMI.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mdiInformationVariant } from '@mdi/js'

export default {
    data: () => ({
        mdiInformationVariant,
        claimApprovals: [
            'When a Member undergoes emergency treatment or hospitalization in a non-HMI affiliated hospital and the member advances the expenses incurred based on the stipulated limits.',
            'When a member sustains injuries or other medical conditions resulting from medico-legal cases.',
            'When a member incurs expenses and advances payments for services duly authorized and covered by the provisions and articles of the HMI Service Agreement.'
        ],
        claimsReimburses: [
            'Official receipts, and itemized breakdown of hospital charges or charge slips;',
            'Statement of Account;',
            'Clinical Abstract or discharge summary authenticated by the proper hospital authorities;',
            'Results of diagnostic and laboratory examination;',
            'Operative record, including histopathological report if a surgical procedure was performed;',
            'ER medical certificate, or Attending Physician\'s Report;',
            'Police Report or Blotter, and medico-legal Report for all 	medico-legal cases;',
            'Driver\'s License and Official Receipt, and valid vehicle Official 	Receipt and Certificate of Registration for vehicular accident 	cases;',
            'Where Applicable, Subrogation Agreement (Deed of 	Assignment of Rights) duly signed by the HMI member, or 	guardian (if minor) 	or legal representative, in case of death, 	or disability, or medico-legal cases, or cases involving a third 	party. '
        ]
    })
}
</script>

<style scoped>
section {
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}

.claims-col-content {
  width: 700px;
  margin: 20px auto;
}
.claims-col-content .reimbursement img {
  width: 100%;
}
.content {
  width: 90%;
  margin: auto;
}
.content p {
  text-align: justify;
}
.claims-col-content h3 {
  font-size: 30px;
  color: #1b5e20;
}
.claims-col-content h4 {
  width: 80%;
  margin-top: 20px;
  text-align: justify;
}

.claims-col-content ul {
  width: 80%;
}
.claims-col-content ul li {
  padding-top: 20px;
  font-size: 15px;
  text-align: justify;
}
@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}
@media (max-width: 599px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    padding-top: 10px;
    font-size: 25px;
  }
  .content {
    width: 95%;
  }
  .claims-col-content h4 {
    width: 100%;
  }
  .claims-col-content h3 {
    font-size: 25px;
    text-align: center;
  }
  .claims-col-content ul {
    width: 95%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    padding-top: 10px;
    font-size: 30px;
  }
  .claims-col-content {
    width: 80%;
  }
  .content {
    width: 100%;
  }
  .claims-col-content h4 {
    width: 100%;
  }
  .claims-col-content h3 {
    font-size: 25px;
    text-align: center;
  }
}
@media (min-width: 968px) and (max-width: 1264px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    padding-top: 10px;
    font-size: 30px;
  }
  .claims-col-content {
    width: 100%;
  }
  .content {
    width: 90%;
  }
  .claims-col-content h4 {
    width: 100%;
  }
  .claims-col-content h3 {
    font-size: 25px;
    text-align: center;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .claims-col-content {
    width: 45%;
  }
  .content {
    width: 90%;
  }
  .claims-col-content h4 {
    width: 100%;
  }
  .claims-col-content h3 {
    font-size: 25px;
    text-align: center;
  }
}
</style>
